// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"44":"37afe34a","298":"03a43d15","376":"2767e06b","394":"4f4cd4a8","422":"bcc1e7f6","429":"ddaed52a","542":"8fbbf014","860":"ae2ae4e4","911":"3b7671a7","938":"abcc4f09","984":"336247e1"}[chunkId] + ".js";
};